import { useState } from 'react';
import { FolderOpen, Plus, ChevronDown, ChevronRight } from 'lucide-react';
import SidebarNavItem from '@/components/SidebarNavItem';

/**
 * Collapsible notebooks section in the sidebar.
 */
export default function SidebarNotebookList({
  notebooks, noteCountByNotebook, filterNotebookId,
  handleNavClick, onAddNotebook,
  dragOverNotebook, setDragOverNotebook, handleNoteDrop,
}) {
  const [open, setOpen] = useState(true);

  return (
    <div className="pt-4">
      <div className="flex items-center gap-1.5 px-3 py-2 w-full min-h-[36px] cursor-pointer hover:bg-muted/30">
        <button onClick={() => setOpen(!open)} className="flex items-center gap-1.5 flex-1" data-testid="sidebar-notebooks-toggle">
          {open ? <ChevronDown className="w-3.5 h-3.5" /> : <ChevronRight className="w-3.5 h-3.5" />}
          <span className="text-xs uppercase tracking-[0.1em] text-muted-foreground font-medium">Notebooks</span>
        </button>
        <button onClick={(e) => { e.stopPropagation(); onAddNotebook(); }} className="p-1.5 -mr-1 text-muted-foreground hover:text-foreground active:text-foreground" data-testid="sidebar-add-notebook-btn">
          <Plus className="w-4 h-4" />
        </button>
      </div>
      {open && (
        <div className="mt-0.5 space-y-0.5">
          {notebooks.map((nb) => (
            <SidebarNavItem
              key={nb.id}
              icon={FolderOpen}
              label={nb.name}
              count={noteCountByNotebook[nb.id] || 0}
              active={filterNotebookId === nb.id}
              onClick={() => handleNavClick('all', nb.id, null)}
              testId={`sidebar-notebook-${nb.id}`}
              droppable
              notebookId={nb.id}
              dragOverNotebook={dragOverNotebook}
              setDragOverNotebook={setDragOverNotebook}
              handleNoteDrop={handleNoteDrop}
            />
          ))}
          {notebooks.length === 0 && (
            <p className="text-xs text-muted-foreground/50 px-3 py-2">No notebooks yet</p>
          )}
        </div>
      )}
    </div>
  );
}
